module.exports = ".sign-in-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.authorization-group {\n  margin-top: 6%;\n  width: 400px;\n  background: #fff;\n  border: 1px rgba(210, 210, 210, 0.75) solid;\n  border-radius: 10px; }\n\n.change-from-type {\n  border: revert;\n  margin-top: 10px;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/sign-in.component.scss
// module id = ./src/app/modules/auth/sign-in.component.scss
// module chunks = main